import React from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { FooterBaseStyle}from "./ReportStyle";

type ReportPageFooterProps = {
  onClickSelectButton: () => void;
  buttonEnable: boolean;
};

const ReportPageFooter: React.FC<ReportPageFooterProps> = (props) => {
  const { t } = useTranslation();
  const footerBaseStyle = FooterBaseStyle();
  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          variant="contained"
          className={footerBaseStyle.buttonStyle}
          color="primary"
          disabled={!props.buttonEnable}
          disableElevation
          onClick={(e) => {
            props.onClickSelectButton();
          }}
        >
          {t('ReportPageFooter.実行','実行')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ReportPageFooter;
